console.log('adaptive modal v.1.3.9');

export const modals = (() => {
  let modalList = [];
  let current = modalList.length;
  let currentModalId = '';

	return {
    /**
     * Creates modal instance 
     * @param {String} title of the modal
     * @param {String} the whole body of the modal
     * @param {String} actions for the footer of the modal (buttons etc)
     * @param {Object} configuration object, see config method for details
     */

		create: (title, body, footer, configuration) => {
      const config = modals.config(configuration);
      currentModalId = configuration.id;

			let modalAlignClass = "";

			if (config.align != "") {
				modalAlignClass = `adaptive-modal--${align}`;	
			}
			
			const modalHTML = `
				<div ${config.id} class="adaptive-modal shadow--large ${modalAlignClass} ${config.type}" role="modal" aria-hidden="false">
					${modals.createHeader(title, config)}
					${modals.createBody(body, config.bodyClass)}
					${modals.createFooter(footer)}
				</div>
			`;

      let modal = {
        id: 1,
        content: modalHTML
      }

      // insert the modal into the body
			modals.createOverlay();
			document.body.style.overflowY = 'hidden';
			document.body.insertAdjacentHTML('beforeend', modalHTML);
      // store a reference to the modal
      modals.set.modal(configuration);
			document.addEventListener('keyup', modals.handleEscape);

      document.addEventListener('click', function(event) {
        if (event.target.classList.contains('modal-backdrop-light') || event.target.classList.contains('close')) {
          modals.destroy(event.target);
        }

        if (event.target.getAttribute('data-action') && event.target.dataset.action == 'go-back') {
          modals.navigate.previous();     
        }
      });
		},
    get: {
      modal: () => {
        return window.MODALREF;
      }
    },
    set: {
      modal: (configuration) => {
        window.MODALREF = document.querySelector(`#${configuration.id}`);
      },
    },
    navigate: {
      previous: () => {
        const modal = document.querySelector(`#${currentModalId}`);

        if (modalList.length == 0) {
          return;
        }
         
        current--;
        modal.innerHTML = modalList[current].content;
        modalList.pop();
      }
    },

    /**
     * Configuration object
     * @param {String} align - alignment of the modal
     * @param {Boolean} hasHeaderImage
     * @param {String} headerImageUrl
     * @param {String} id - id for the modal
     * @param {String} type
     * TODO: Set a default custom generated id, override with custom id
     */
    config: (input = {}) => {
      let configuration = {
        'align': input.align || '',
        'hasHeaderImage': input.hasHeaderImage || false,
        'headerImageUrl': input.headerImageUrl || '',
        'id': modals.setId(input.id),
        'type': input.type || '',
        'headerClass': input.headerClass || '',
        "backButton": input.backButton || false,
        'bodyClass': input.bodyClass || ''
      }

      return configuration;
    },
    setId: (input) => {
      if (input) {
        return `id="${input}"`;
      }
      else {
        return '';
      }
    },
    /**
     * Create the adaptive modal overlay which is shown behind the modal
     */
    createReference: () => {

    },
		createOverlay: () => {
			const background = `<div class="modal-backdrop-light in"></div>`;
			document.body.insertAdjacentHTML('beforeend', background);
		},


    /**
     * create the header element of the modal
     * @param {String} title - the title of the modal
     * @param {Object} config object 
     */

		createHeader: (title, config) => {
			let header = '';
			let closeSvg = '';

			if (title != '') {
				config.headerClass += ' has-title';
			}

			if (config.hasHeaderImage) {
				closeSvg = `
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
						<path d="M12.3331 1.6667L1.66641 12.3334" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M12.3331 12.3334L1.66641 1.6667" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				`;
			}
			else {
				closeSvg = `
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
						<path d="M16 1.61714L14.3829 0L8 6.38286L1.61714 0L0 1.61714L6.38286 8L0 14.3829L1.61714 16L8 9.61714L14.3829 16L16 14.3829L9.61714 8L16 1.61714Z" fill="black"/>
					</svg>
				`;	
			}

      let actionLeft = `
        <div class="action-left">
          <button class="back" data-action="go-back"> 
            <span aria-hidden="true">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12H5" stroke="#078372" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 19L5 12L12 5" stroke="#078372" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </button>
        </div>
      `;

			let actionRight = `
				<div class="action-right">
					<button class="close" aria-label="close" data-dismiss="modal">
						<span aria-hidden="true">
						${closeSvg}	
						</span>
					</button>
				</div>
			`;

			if (config.hasHeaderImage) {
				header = `
					<header class="header-image-container">
						<img src="${config.headerImageUrl}" class="header-image"/>
						${actionRight}
					</header>
				`;
			}
			else {
				header = `
					<header class="${config.headerClass}">
            ${config.backButton == true ? actionLeft : ''}
						<h2 class="title">${title}</h2>
						${actionRight}
					</header>
				`;
			}

			return header;
		},

    /**
     * create the footer element of the modal
     * @param {String} actions - the actions that can be shown in the footer 
     */
		createFooter: (actions = "") => {
			if (actions != "") {
				const footer = `
					<footer>
						${actions}
					</footer>
				`;

				return footer;
			}
			return "";
		},

    /**
     * create the body element of the modal
     * @param {String} content - all the content that will be shown in the main element of the modal 
     * @param {String{ bodyClass
     */

		createBody: (content, bodyClass) => {
			const body = `
				<main class="adaptive-modal-content ${bodyClass}">
					${content}
				</main>
			`;

			return body;
		},
    
    /**
     * alternative to modals.create method 
     */

		open: () => {
			modals.create();
		},
    /**
     * modals.close method
     * closes the current modal
     */
		close: () => {
			const currentModal = document.querySelector('.modal');
			currentModal.classList.add('hidden');
		},

    /**
     * destroy the modal
     * @param {String} target (html element) - the modal to destroy
     */

		destroy: (target) => {
			var currentModal;
			var overlay = document.querySelector('.modal-backdrop-light');

			if (target) {
				target.classList.contains('modal-backdrop-light') ? currentModal = target.nextElementSibling : currentModal = target.closest('.adaptive-modal');
			}
			else {
				currentModal = overlay.nextElementSibling;
			}

			if (currentModal !== null && overlay !== null) {
				currentModal.remove();
				overlay.remove();
			}

			document.body.style.overflowY = 'auto';
      modalList.length = 0;
		},
    destroyAll: () => {
      const overlays = document.querySelectorAll('.modal-backdrop-light');
      const modals = document.querySelectorAll('.adaptive-modal');

      modals.forEach(modal => {
        modal.remove();
      });
    
      overlays.forEach(overlay => {
        overlay.remove();
      });

      modalList.length = 0;
    },

    /*
     * Updates the content of the modal while keeping the old content so a single modal can be used for a multi step purpose
     */

    update: (title, body, footer, config) => {
      const currentModal = document.querySelector(`#${currentModalId}`);

      const old = {
        id: current + 1,
        content: currentModal.innerHTML
      };

			const newContent = `
        ${modals.createHeader(title, config)}
        ${modals.createBody(body, config.bodyClass)}
        ${modals.createFooter(footer)}
			`;

      modalList.push(old);
      currentModal.innerHTML = newContent;
      current++;
    },

    /**
     * handleEscape - close the modal when pressing the escape key
     * @param {Event} 
     */
		handleEscape: (event) => {
			if (event.key == 'Escape') {
				modals.destroy();
			}
		}
	}
})();
